export default __webpack_public_path__ + "2513f8c81cbfd0fd16e3397fb40e61b8.svg";